/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 * SCS.utils
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * ScFormArchive module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class ScFormArchive
	 * @extends Tc.Module
	 */
	Tc.Module.ScFormArchive = Tc.Module.extend({

		cookieName: 'FormArchiveFilter',

		Events: {
			loadingClicked: 'loadingClicked', // no data when firing
			loadingStart: 'loadingStart', // no data when firing
			loadingStop: 'loadingEnd', // no data when firing
			noResults: 'noResults', // no data when firing
			resetResults: 'resetResults', // no data when firing
			resultsUpdated: 'resultsUpdated', // fired with data: { size: (overall size of the results), count (currently displayed entries) }
			itemAdded: 'itemAdded', // fired with data: { item (all data for this entry from backend), row (jquery element of the added table row) }
			update: 'update' // fired by modules whose data has changed, passing the new values, listened to by modules which need the updated data
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			this.isMobile = SCS.utils.isMobilePage();

			this.LoadingIndicator.init($('.js-loading-indicator', this.$ctx), this);
			this.LoadButton.init($('.js-load-button', this.$ctx), this);
			this.SizeIndicator.init($('.showcount', this.$ctx), this);
			this.ResultTable.init($('table', this.$ctx), this);
			this.ActionsHandler.init($('table', this.$ctx), this);
			this.SortHandler.init($('table thead', this.$ctx), this);
			//this.Search.init($('form', this.$ctx), this);
			callback();
		},

		showDialog: function(title, text) {
			if(!this.isMobile){
				$('<div/>').attr('title', title).append(text).dialog();
			} else {
				var $popup = $('<div/>').attr('title', title).append(text);
				$popup.popup({
					afterclose: function( event, ui ) {
						$popup.popup('destroy');
					}
				}).popup('open');
			}
		},

		setCookieValue: function(name, value) {
			try {
				var data = $.cookies.get(this.cookieName) || {};
				data[name] = value;

				$.cookies.set(this.cookieName, data, {
					hoursToLive: 1
				});
			} catch(e) {}
		},

		getCookieValue: function(name) {
			try {
				var data = $.cookies.get(this.cookieName) || {};
				if (typeof data !== 'object') {
					data = $.parseJSON(data);
				}
				if (data && data.hasOwnProperty(name)) {
					return data[name];
				}
			} catch(e) {}
			return null;
		},

		/**
		 * Hook function to trigger your events.
		 *
		 * @method after
		 * @return void
		 */
		after: function() {
			this.Search.init($('form', this.$ctx), this);

			this.Search.start();
			this.SortHandler.start();
			this.ResultTable.start();
		},

		LoadingIndicator: {
			init: function(element, parent) {
				this.element = element;
				parent.$ctx.on(parent.Events.loadingStart, $.proxy(this.start, this));
				parent.$ctx.on(parent.Events.loadingStop, $.proxy(this.stop, this));
				this.stop();
			},

			start: function() {
				this.element.show();
			},

			stop: function() {
				this.element.hide();
			}
		},

		LoadButton: {
			init: function(element, parent) {
				this.element = element;
				this.parent = parent;

				this.parent.$ctx.on(this.parent.Events.loadingStart, $.proxy(this.disable, this));
				this.parent.$ctx.on(this.parent.Events.loadingStop, $.proxy(this.enable, this));
				this.parent.$ctx.on(this.parent.Events.noResults, $.proxy(this.stop, this));
				this.parent.$ctx.on(this.parent.Events.resetResults, $.proxy(this.reset, this));
				this.element.on('click', $.proxy(this.clickHandler, this));
			},

			clickHandler: function(event) {
				event.preventDefault();
				this.parent.$ctx.trigger(this.parent.Events.loadingClicked);
			},

			enable: function() {
				if (!this.stopped) {
					this.element.removeClass('disabled');
					this.element.show();
				}
			},

			disable: function() {
				if (!this.stopped) {
					this.element.addClass('disabled');
					this.element.hide();
				}
			},

			stop: function() {
				this.disable();
				this.stopped = true;

			},

			reset: function() {
				this.stopped = false;
				this.enable();
			}
		},

		SizeIndicator: {
			init: function(element, parent) {
				this.element = element;
				parent.$ctx.on(parent.Events.resultsUpdated, $.proxy(this.update, this));
			},

			update: function(event, data) {
				var size = (data ? data.size : 0) || 0,
					count = (data ? data.count : 0) || 0;
				if (!this.text) {
					this.text = this.element.text();
				}
				this.element.text((this.text || '').replace('(count)', count).replace('(size)', size)).show();
			}
		},

		ResultTable: {
			Data: {
				url: 'page-path',
				errorMsg: 'error-msg',
				statusDraftText: 'txt-status-draft',
				statusSentText: 'txt-status-sent'
			},

			init: function(element, parent) {
				this.element = element;
				this.parent = parent;
				this.count = 0;
				this.finalSize = 0;
				this.Filter = {};
				this.parent.$ctx.on(this.parent.Events.resetResults, $.proxy(this.reset, this));
				this.parent.$ctx.on(this.parent.Events.loadingClicked, $.proxy(this.loadData, this));
				this.parent.$ctx.on(this.parent.Events.update, $.proxy(this.updateHandler, this));
			},

			start: function() {
				this.parent.$ctx.trigger(this.parent.Events.resetResults);
			},

			getPagePath: function() {
				if (!this.pagePath) {
					this.pagePath = this.getProperty(this.Data.url);
				}
				return this.pagePath;
			},

			loadData: function() {
				if (!this.currentlyLoading) {
					this.currentlyLoading = true;
					this.abortingAjax = false;
					this.parent.$ctx.trigger(this.parent.Events.loadingStart);
					var $this = this;
					this.Filter.offset = this.count;
					if (!this.Filter['_charset_']) {
						this.Filter['_charset_'] = "utf-8";
					}
					this.ajaxCall = $.ajax({
						type: 'GET',
						url: $this.getPagePath() + '.formarchive.list.json',
						cache: false,
						dataType: 'json',
						data: $this.Filter,
						traditional: true,
						success: $.proxy($this.loadDataSuccess, $this),
						error: $.proxy($this.loadDataError, $this)
					});
				} else {
					if (this.ajaxCall) {
						this.abortingAjax = true;
						this.ajaxCall.abort();
					}
					this.loadData();
				}
			},

			loadDataSuccess: function(data) {
				if( data && data.items && data.items.length > 0 ) {
					this.finalSize = data.size;
					this.append(data.items);
					if (data.size && this.count >= data.size) {
						this.parent.$ctx.trigger(this.parent.Events.noResults);
					}
				} else {
					this.parent.$ctx.trigger(this.parent.Events.noResults);
				}
				this.notifyNewSize();
				this.currentlyLoading = false;
				this.parent.$ctx.trigger(this.parent.Events.loadingStop);
			},

			loadDataError: function() {
				this.currentlyLoading = false;
				if (!this.abortingAjax) {
					this.parent.showDialog('Error', this.getProperty(this.Data.errorMsg));
				}
				this.notifyNewSize();
				this.parent.$ctx.trigger(this.parent.Events.loadingStop);
			},

			updateHandler: function(event, data) {
				var filterChanged = false,
					key;
				if (data) {
					for (key in data) {
						if (data.hasOwnProperty(key)) {
							if (data[key] === '' || data[key] === undefined || data[key] === null) {
								if (this.Filter.hasOwnProperty(key)) {
									delete this.Filter[key];
									filterChanged = true;
								}
							} else {
								if (this.Filter[key] !== data[key]) {
									this.Filter[key] = data[key];
									filterChanged = true;
								}
							}
						}
					}
				}
				if (filterChanged) {
					this.parent.$ctx.trigger(this.parent.Events.resetResults);
				}
			},

			reset: function() {
				this.count = 0;
				this.finalSize = 0;
				this.getContent().empty();
				this.loadData();
			},

			append: function(data) {
				if (data) {
					for (var i = 0; i < data.length; i++) {
						this.addRow(data[i]);
					}
					this.notifyNewSize();
				}
			},

			notifyNewSize: function() {
				var $this = this;
				this.parent.$ctx.trigger(this.parent.Events.resultsUpdated, { size: $this.finalSize || $this.count, count: $this.count });
			},

			addRow: function (item) {
				var content = $('<tr/>'),
					shortSummary = item.shortSummary !== null && item.shortSummary !== '' ? item.shortSummary.trim() : ' ';
				shortSummary = $('<div/>').html(shortSummary).text();
				content.append(this.getCell(item.formId, 'cell-form-type'));
				content.append(this.getCell(item.lastUpdated, 'cell-last-updated'));
				if (item.draft === true) {
					content.append(this.getCell(this.getProperty(this.Data.statusDraftText), 'cell-status'));
				} else {
					content.append(this.getCell(this.getProperty(this.Data.statusSentText), 'cell-status'));
				}
				content.append(this.getCell($('<span class="content"/>').html(shortSummary), 'cell-summary'));

				//add header texts to table cells
				if(this.parent.isMobile){
					content.find('.cell-last-updated').prepend(this.element.find('th.cell-last-updated > span').clone());
					content.find('.cell-status').prepend(this.element.find('th.cell-status > span').clone());
					if ($.trim(content.find('.cell-summary .content').text()).length){
						content.find('.cell-summary .content').prepend(this.element.find('th.cell-summary > span').clone());
					}
				}

				this.getContent().append(content);
				this.count++;
				this.parent.$ctx.trigger(this.parent.Events.itemAdded, { item: item, row: content });
			},

			getCell: function(content, cssClass) {
				var cell = $('<td/>');
				if (cssClass) cell.addClass(cssClass);
				if (content !== undefined) {
					if (typeof content === 'string') {
						cell.text(content);
					} else {
						cell.append(content);
					}
				}
				return cell;
			},

			getProperty: function(name, defaultValue) {
				return this.element.data(name) || defaultValue;
			},

			getContent: function() {
				if (!this.content) {
					this.content = $('tbody', this.element);
				}
				return this.content;
			}
		},

		SortHandler: {
			SortDirections: {
				ascending: 'asc',
				descending: 'desc'
			},

			SortCellClass: {
				ascending: 'sort-asc',
				descending: 'sort-desc'
			},

			Data: {
				defaultSortBy: 'default-sort-by',
				defaultSortDirection: 'default-sort-direction'
			},

			init: function(element, parent) {
				this.element = element;
				this.parent = parent;
				this.sortName = this.getProperty(this.Data.defaultSortBy, '');
				this.sortDirection = this.getProperty(this.Data.defaultSortDirection, '');
				this.element.on('click', 'th', $.proxy(this.handler, this));
				this.updateHeader();
			},

			start: function() {
				var $this = this;
				this.parent.$ctx.trigger(this.parent.Events.update, { sort: $this.sortName, sortDirection: $this.sortDirection });
			},

			getProperty: function(name, defaultValue) {
				return this.element.data(name) || defaultValue;
			},

			handler: function(event) {
				var el = $(event.currentTarget),
					name = el.data('name'),
					$this = this;
				if (name) {
					if (name === this.sortName) {
						if (this.sortDirection === this.SortDirections.descending) {
							this.sortDirection = this.SortDirections.ascending;
						} else {
							this.sortDirection = this.SortDirections.descending;
						}
					} else {
						this.sortName = name;
						this.sortDirection = this.SortDirections.descending;
					}
					this.updateHeader();
					this.parent.$ctx.trigger(this.parent.Events.update, { sort: $this.sortName, sortDirection: $this.sortDirection });
				}
			},

			updateHeader: function() {
				var $this = this;
				$('th', this.element).each(function() {
					var el = $(this),
						name = el.data('name');
					if (name) {
						if (name === $this.sortName) {
							if ($this.sortDirection === $this.SortDirections.ascending) {
								el.removeClass($this.SortCellClass.descending);
								el.addClass($this.SortCellClass.ascending);
							} else {
								el.removeClass($this.SortCellClass.ascending);
								el.addClass($this.SortCellClass.descending);
							}
						} else {
							el.removeClass($this.SortCellClass.ascending);
							el.removeClass($this.SortCellClass.descending);
						}
					}
				});
			}
		},

		ActionsHandler: {
			Type: {
				edit: 'edit',
				copy: 'copy',
				view: 'view',
				remove: 'remove'
			},

			Data: {
				url: 'page-path',
				layerWidth: 'view-width',
				sentOnText: 'txt-sent-on',
				layerCopyButtonText: 'txt-layer-button-copy',
				errorMsg: 'error-msg',
				editText: 'txt-edit',
				copyText: 'txt-copy',
				viewText: 'txt-view',
				removeText: 'txt-remove',
				removeQuestionText: 'txt-remove-question',
				yesText: 'txt-yes',
				noText: 'txt-no'
			},

			init: function(element, parent) {
				this.element = element;
				this.parent = parent;
				this.parent.$ctx.on(this.parent.Events.itemAdded, $.proxy(this.setActionsHandler, this));
			},

			getProperty: function(name, defaultValue) {
				return this.element.data(name) || defaultValue;
			},

			getPagePath: function() {
				if (!this.pagePath) {
					this.pagePath = this.getProperty(this.Data.url);
				}
				return this.pagePath;
			},

			setActionsHandler: function(event, data) {
				if (data) {
					var actionsContainer = (!this.parent.isMobile) ? $('<span class="button-list"/>') : $('<ul class="link-list button-list"/>'),
						actions = this.getAvailableActions(data.item),
						i, $li;
					for (i = 0; i < actions.length; i++) {
						if(this.parent.isMobile){
							$li = $('<li></li>').appendTo(actionsContainer);
							$li.append(this.getElement(actions[i], data.item));
						} else {
							actionsContainer.append(this.getElement(actions[i], data.item));
						}
					}
					$('td:last-child', data.row).append(actionsContainer);
				}
			},

			getAvailableActions: function(item) {
				var actions = [];
				if (item.draft !== true) {
					actions.push(this.Type.view);
				}
				if (item.draft === true) {
					actions.push(this.Type.remove);
				}
				if (item.formPageExists === true && item.migratedData !== true) {
					if (item.draft === true) {
						actions.push(this.Type.edit);
					} else {
						actions.push(this.Type.copy);
					}
				}

				return actions;
			},

			getElement: function(actionType, item) {
				var action = $('<a/>').attr('href', this.getUrl(actionType, item));
				if (actionType === this.Type.view) {
					action.text(this.getProperty(this.Data.viewText));
					action.data('item', item);
					action.on('click', $.proxy(this.viewClickHandler, this));
				} else if (actionType === this.Type.edit) {
					action.text(this.getProperty(this.Data.editText));
				} else if (actionType === this.Type.copy) {
					action.text(this.getProperty(this.Data.copyText));
				} else if (actionType === this.Type.remove) {
					action.text(this.getProperty(this.Data.removeText));
					action.data('item', item);
					action.on('click', $.proxy(this.removeClickHandler, this));
				}
				return action;
			},

			getUrl: function(actionType, item) {
				if (actionType === this.Type.edit) {
					return item.formPath + '.html?action=edit&entryId=' + item.id;
				} else if (actionType === this.Type.copy) {
					return item.formPath + '.html?action=copy&entryId=' + item.id;
				} else {
					return item.formPath + '.html';
				}
			},

			viewClickHandler: function(event) {
				event.preventDefault();
				if (!this.viewLayer) {
					var $this = this,
						item = $(event.currentTarget).data('item');

					this.viewLayer = $('<div/>')
						.addClass('ui-dialog-lightbox-content modScFormArchive archive-preview')
						.append($('<div/>').addClass('js-loading-indicator')); // loading indicator

					if(!this.parent.isMobile){
							this.viewLayer.dialog({
								classes: {'ui-dialog': 'ui-dialog-lightbox pex-ui-dialog-lightbox'},
								width: $this.getProperty($this.Data.layerWidth) || 600,
								height: 'auto',
								position: { 'my': 'center', 'at': 'center' },
								close: function() {
									$this.viewLayer.remove();
									$this.viewLayerOpen = false;
									$this.viewLayer = null;
								}
						});
					} else {
						this.viewLayer.addClass('form-archive-panel').appendTo('.ui-page');
					}

					$.ajax({
						type: 'GET',
						url: $this.getPagePath() + '.formarchive.item.json',
						cache: false,
						dataType: 'json',
						data: {
							entryId: item.id
						},
						success: $.proxy($this.displayViewLayer, $this),
						error: function () {
							$this.parent.showDialog('Error', $this.element.data($this.Data.errorMsg));
							$this.viewLayer = null;
						}
					});
				}
			},

			displayViewLayer: function(data) {
				if (this.viewLayer) {
					this.viewLayer.empty();
					var summary = $('<div/>').html(data.summary).text(), // decode html
						copyLink = $('<a class="primary-button"/>').attr('href', this.getUrl(this.Type.copy, data)).text(this.getProperty(this.Data.layerCopyButtonText)),
						hr = ($('<hr/>')),
						$this = this;


					this.viewLayer.append($('<h2/>').text(data.pageTitle)); // title
					this.viewLayer.append($('<p/>').addClass('senttime').text(this.getProperty(this.Data.sentOnText) + ' ' + data.lastUpdated)); // submitting date
					this.viewLayer.append($('<div/>').addClass('content').html(summary)); // summary
					if (data.formPageExists === true && data.migratedData !== true) {
						this.viewLayer.append($('<hr/>'));
						this.viewLayer.append($('<div/>').append(copyLink));
					}
					if (this.viewLayer.height() > $(window).height()) {
						window.scrollTo(0, 0);
					}
					if(!this.parent.isMobile){
						this.viewLayer.dialog('reposition');
					} else {
						$('html').addClass('has-form-archive-dialog');
						this.viewLayer.prepend(hr);
						this.viewLayer.prepend(this.parent.$ctx.find('.form-remove-panel-back').clone());
						this.viewLayer.find('.form-remove-panel-back').click(function(){
							$('html').removeClass('has-form-archive-dialog');
							$this.viewLayer.remove();
							$this.viewLayerOpen = false;
							$this.viewLayer = null;
						});
					}
				}
			},

			removeClickHandler: function(event) {
				event.preventDefault();
				if (!this.removeLayer) {
					this.removeTarget = $(event.currentTarget);
					var $this = this,
						item = $(event.currentTarget).data('item'),
						question = $('<h3/>').text((this.getProperty(this.Data.removeText|| ''))),
						copytext = $('<p/>').text((this.getProperty(this.Data.removeQuestionText) || '').replace('(form)', item.formId)),
						buttonYes = $('<a class="archiv-button primary-button" href="#"/>').text((this.getProperty(this.Data.yesText) || '')).on('click', { item: item }, $.proxy(this.removeClickConfirmedHandler, this)),
						buttonNo = $('<a class="archiv-button  secondary-button" href="#"/>').text((this.getProperty(this.Data.noText) || '')).on('click', $.proxy(this.removeClickDiscardedHandler, this)),
						hr = ($('<hr/>'));
					this.removeLayer = $('<div/>').append(question).append(copytext).append(hr).append(buttonYes).append(buttonNo);

					if(!this.parent.isMobile){
						this.removeLayer.addClass('ui-dialog-lightbox-content modScFormArchive archive-preview').dialog({
							classes: {'ui-dialog': 'ui-dialog-lightbox'},
							width: 400,
							height: 'auto',
							close: function() {
								$this.removeLayer.remove();
								$this.removeLayer = null;
							}
						});
					} else {
						this.removeLayer.prepend(hr);
						this.removeLayer.prepend(this.parent.$ctx.find('.form-remove-panel-back').clone());
						this.removeLayer.find('.form-remove-panel-back').on('click', $.proxy(this.removeClickDiscardedHandler, this));
						this.removeLayer.addClass('form-archive-panel').appendTo('.ui-page');

					}
				}
			},

			removeClickConfirmedHandler: function(event) {
				event.preventDefault();
				if (event.data.item) {
					var $this = this;
					if (this.removeLayer) {
						this.removeLayer.empty().append($('<div/>').addClass('js-loading-indicator'));
					}
					$.ajax({
						type: 'POST',
						url: $this.getPagePath() + '.formarchive.delete.json',
						cache: false,
						dataType: 'json',
						data: {
							entryId: event.data.item.id
						},
						success: $.proxy($this.removeSuccess, $this),
						error: function () {
							if ($this.removeLayer) {
								if(!this.parent.isMobile){
										$this.removeLayer.dialog('close');
								} else {
									$this.removeLayer.remove();
								}
							}
							$this.parent.showDialog('Error', $this.element.data($this.Data.errorMsg));
						}
					});
				}
			},

			removeClickDiscardedHandler: function(event) {
				event.preventDefault();
				if (this.removeLayer) {
					if(!this.parent.isMobile){
							this.removeLayer.dialog('close');
					} else {
						this.removeLayer.remove();
						this.removeLayer = null;
					}
				}
				this.removeTarget = null;
			},

			removeSuccess: function(data) {
				if (this.removeLayer) {
					if(!this.parent.isMobile){
							this.removeLayer.dialog('close');
					} else {
						this.removeLayer.remove();
					}
				}
				if (data && (data.success === true || data.success === 'true')) {
					if (this.removeTarget) {
						this.removeTarget.closest('tr').remove();
					}
				} else {
					this.parent.showDialog('Error', this.element.data(this.Data.errorMsg));
				}
				this.removeTarget = null;
			}
		},

		Search: {
			init: function(element, parent) {
				var $this = this;
				this.element = element;
				this.parent = parent;
				this.Filter = {};
				this.searchButton = $('.js-search-button', this.element).on('click', $.proxy(this.fireUpdate, this));
				$('[data-filter-name]', this.element).each(function() {
					$this.addFilter($(this));
				});
			},

			start: function() {
				this.fireUpdate();
			},

			addFilter: function(el) {
				var inputField = $(':input', el),
					datePicker = $('.modDatePicker', el),
					name = el.data('filter-name'),
                    searchRef = this,
					value = this.parent.getCookieValue(name);
				if (value) {
					this.setInputValue(inputField, value);
					this.Filter[name] = value;
				}
				inputField.on('change', { element: el }, $.proxy(this.changeEventHandler, this));
				if(datePicker.length > 0) {
				    $("#ui-datepicker-div").hide();
					inputField.datepicker("option", "onSelect", function() {
						value = searchRef.getInputValue(inputField);
						searchRef.Filter[name] = value;
						searchRef.parent.setCookieValue(name, value);
					});

				}
				inputField.on('keyup', $.proxy(this.enterPressedHandler, this));
			},

			enterPressedHandler: function(event) {
				if(event.keyCode === 13){
					$(event.currentTarget).trigger('change', { forceUpdate: true });
				}
			},

			fireUpdate: function(event) {
				if (event) {
					event.preventDefault();
				}
				this.parent.$ctx.trigger(this.parent.Events.update, this.Filter);
			},

			changeEventHandler: function(event, data) {
                var el = event.data.element,
					name, value;
				if (el) {
					value = this.getInputValue($(event.currentTarget));
					name = el.data('filter-name');
					this.Filter[name] = value;
					this.parent.setCookieValue(name, value);
					if ((el.data('filter-autoupdate') !== 'false' && el.data('filter-autoupdate') !== false) ||
						(data && data.forceUpdate === true)) {
						this.fireUpdate();
					}
				}
			},

			getInputType: function(input) {
				if (input && input.length > 0) {
					return input[0].type || input[0].tagName.toLowerCase();
				}
				return null;
			},

			getInputValue: function(input) {
				var type = this.getInputType(input),
					value = null;
				if (type === 'radio' || type === 'checkbox') {
					value = [];
					$(':input[name="' + input.attr('name') + '"]', this.element).each(function() {
						if ($(this).is(':checked')) {
							value.push(this.value);
						}
					});
				} else {
					value = input.val();
				}
				return value;
			},

			setInputValue: function(input, value) {
				var type = this.getInputType(input);
				if (type === 'radio' || type === 'checkbox') {
					$(':input[name="' + input.attr('name') + '"]', this.element).each(function() {
						if (this.value === value || (value instanceof Array && $.inArray(this.value, value) >= 0)) {
							var $this = $(this);
							$this.prop('checked', true);
							$this.trigger('change');
						}
					});
				} else if (type) {
					input.val(value);
					input.trigger('change');
				}
			}
		}
	});

}(Tc.$, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ScFormArchive.js
// module id = 180
// module chunks = 0